module.exports = __webpack_public_path__ + "media/images/icons/twotone/mobile-6c2014025de171f16c8f2263fd594779.svg";